export default async function downloadImage (linkUrl){
    let url = linkUrl;
    const response = await fetch(url);
    const blobImage = await response.blob();

    const href = URL.createObjectURL(blobImage);

    const anchorElement = document.createElement("a");
    anchorElement.href = href;
    anchorElement.download = url.replace(/^.*[\\\/]/, "");

    document.body.appendChild(anchorElement);
    anchorElement.click();

    document.body.removeChild(anchorElement);
    window.URL.revokeObjectURL(href);
}